
import React, { useEffect, useMemo, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { capitalize, isNil } from 'lodash';


import Modal, { ModalHeader, ModalContent, ModalActions } from '@vromo/ui/components/Modal';
import { dataTestId, IntegrationsConfig, Platform } from '@vromo/models';
import OverlayablePanel from '@vromo/ui/components/Overlay';
import Title from '@vromo/ui/components/Title';
import Button from '@vromo/ui/components/Button';
import { useIntegrationsNav, useIntegrationsPage } from '../hooks';
import Select from '@vromo/ui/components/Select2';
import { firstLetterCap } from '@vromo/ui/styles';
import { LabelValue } from '@vromo/models/helpers/models';


export type PlatformOption = LabelValue<string, Platform>



/** modal to select a new integration to create. If integration already exists, it wont be available */
export const IntegrationAdd = observer(() => {

    const { isLoading, availableNewIntegrations } = useIntegrationsPage()
    const { modalOpen, closeModal, goToWindow } = useIntegrationsNav({ modalOpened: true })
    const [platform, setPlatform] = useState<PlatformOption | null>(null)

    const platformOptions: PlatformOption[] = useMemo(() =>
        availableNewIntegrations.map(value => ({ label: capitalize(value), value })), [availableNewIntegrations]
    )

    useEffect(() => { setPlatform(null) }, [availableNewIntegrations])


    return (
        <Modal
            isOpen={modalOpen}
            onRequestClose={() => !isLoading && closeModal()} showCloseButton={!isLoading}
        >
            <OverlayablePanel active={isLoading} loadingText='Loading'>
                <div>
                    <ModalHeader>
                        <Title style={{ textTransform: 'capitalize' }}>Add new integration</Title>
                    </ModalHeader>
                    <ModalContent >
                        <Select
                            value={platform}
                            onChange={(selected: PlatformOption) => setPlatform(selected)}
                            options={platformOptions}
                            placeholder="Select a platform..."
                            data-testid={dataTestId.integration.select}
                        />
                        {
                            !isNil(platform) &&
                            <dl css={firstLetterCap} style={{ maxWidth: "500px", margin: 'auto' }}>
                                <br />
                                <dt >
                                    what this integration does?</dt>
                                <dd >{IntegrationsConfig[platform.value]!.info}</dd>
                            </dl>
                        }
                    </ModalContent>
                    <ModalActions>
                        <Button onClick={closeModal}>
                            Cancel
                        </Button>
                        <Button
                            primary
                            onClick={() => goToWindow("config", platform!.value)}
                            disabled={
                                isNil(platform) ||
                                !IntegrationsConfig[platform.value]?.features.selfOnboard
                            }
                            data-testid={dataTestId.integration.init}
                        >
                            Add
                        </Button>
                    </ModalActions>
                </div>
            </OverlayablePanel>
        </Modal>
    );
});
